import { graphql } from 'react-relay/legacy';

export const checkoutDeliveryOptionsQuery = graphql`
    query checkoutDeliveryOptionsQuery(
        $transactionId: String = ""
        $itemId: String!
        $country: String!
        $city: String
        $state: String
        $zipCode: String
        $currencyConversionRateEventId: String!
        $shouldFetchItemDeliveryOptions: Boolean!
        $shouldFetchTransactionDeliveryOptions: Boolean!
        $quantity: Int
        $fdfQuoteABTestVariant: String
    ) {
        viewer {
            itemDeliveryOptions: availableDeliveryOptions(
                first: 100
                itemId: $itemId
                country: $country
                city: $city
                state: $state
                zipCode: $zipCode
                currencyConversionRateEventId: $currencyConversionRateEventId
                addressResolutionType: ADDRESS
                isCheckout: true
                quantity: $quantity
                fdfQuoteABTestVariant: $fdfQuoteABTestVariant
            ) @include(if: $shouldFetchItemDeliveryOptions) {
                edges {
                    node {
                        ...CheckoutTransactionQueryRenderer_deliveryOptions
                        ...checkoutUIActions_deliveryOptions
                        ...usePreloadedDuties_deliveryOptions
                        sourceId
                        serviceId
                        isLocalPickup
                        totalAmount {
                            amount
                        }
                    }
                }
            }
            transactionDeliveryOptions: availableDeliveryOptions(
                first: 100
                transactionId: $transactionId
                country: $country
                city: $city
                state: $state
                zipCode: $zipCode
                currencyConversionRateEventId: $currencyConversionRateEventId
                addressResolutionType: ADDRESS
                isCheckout: true
                quantity: $quantity
                fdfQuoteABTestVariant: $fdfQuoteABTestVariant
            ) @include(if: $shouldFetchTransactionDeliveryOptions) {
                edges {
                    node {
                        ...CheckoutTransactionQueryRenderer_deliveryOptions
                        ...checkoutUIActions_deliveryOptions
                        ...usePreloadedDuties_deliveryOptions
                        sourceId
                        serviceId
                        isLocalPickup
                        totalAmount {
                            amount
                        }
                    }
                }
            }
        }
    }
`;
